import { useEffect, useState } from "react";
import { navAnchors, siteName } from "@/mocks/media";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 24);
      let current = "";
      for (const anchor of navAnchors) {
        const el = document.getElementById(anchor.id);
        if (el && el.getBoundingClientRect().top <= 120) {
          current = anchor.id;
        }
      }
      setActive(current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkCls = (id: string) =>
    `relative whitespace-nowrap px-1 py-2 text-sm font-medium transition-colors ${
      active === id
        ? "text-foreground-950"
        : scrolled
          ? "text-foreground-700 hover:text-foreground-950"
          : "text-foreground-200 hover:text-white"
    }`;

  const dotCls = (id: string) =>
    `absolute -bottom-0.5 left-1/2 h-1 w-1 -translate-x-1/2 rounded-full transition-opacity ${
      active === id ? "bg-primary-500 opacity-100" : "opacity-0"
    }`;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "border-b border-background-200 bg-background-50/95 backdrop-blur"
          : "border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-[64px] max-w-[1280px] items-center justify-between px-4 md:px-6">
        <a href="#top" className="group flex items-center gap-2.5">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-full transition-colors ${
              scrolled ? "bg-primary-500" : "bg-primary-500/90"
            }`}
          >
            <i className="ri-record-circle-fill text-lg text-background-50" />
          </span>
          <span
            className={`font-heading text-xl font-bold tracking-wide transition-colors ${
              scrolled ? "text-foreground-950" : "text-white"
            }`}
          >
            {siteName}
            <span className="ml-2 align-middle text-[10px] font-normal uppercase tracking-[0.2em] text-primary-500">
              OBSERVER
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-5 md:flex">
          {navAnchors.map((a) => (
            <a key={a.id} href={`#${a.id}`} className={linkCls(a.id)}>
              {a.label}
              <span className={dotCls(a.id)} />
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#about"
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            订阅选题
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className={`flex h-9 w-9 items-center justify-center rounded-md transition-colors md:hidden ${
              scrolled ? "text-foreground-900" : "text-white"
            }`}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} />
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navAnchors.map((a) => (
              <a
                key={a.id}
                href={`#${a.id}`}
                onClick={() => setOpen(false)}
                className={`rounded-lg px-3 py-2.5 text-sm ${
                  active === a.id
                    ? "bg-primary-50 font-medium text-primary-700"
                    : "text-foreground-800 hover:bg-background-100"
                }`}
              >
                {a.label}
              </a>
            ))}
            <a
              href="#about"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex whitespace-nowrap items-center justify-center rounded-full bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
            >
              订阅选题
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}